export default __webpack_public_path__ + "static/media/WM0480.34I-43868_-26184_0.1825c4b4.jpg";